<template>
  <div class="price-breakdown">
    <span class="summary">{{ "price_breakdown.summary" | translate }}</span>
    <span class="underline bold lato">{{
      "price_breakdown.orders" | translate
    }}</span>
    <div
      v-for="[store, products] in Object.entries(getProductsGroupedByStore)"
      v-bind:key="store"
      class="store-total"
    >
      <div class="flex justify-space-between">
        <span>
          {{ "price_breakdown.orders_at" | translate }}
          {{ `store.${store}` | translate }}
        </span>
        <span>CHF {{ sumProductPrices(products) }}.-</span>
      </div>
    </div>
    <div class="flex justify-space-between">
      <span class="bold"> {{ "price_breakdown.subtotal" | translate }}: </span>
      <span class="overline bold">
        CHF {{ calculateTotal(products, vat_included, vat_rate) }}.-
      </span>
    </div>
    <div class="flex justify-space-between">
      <span class="bold">
        {{ "price_breakdown.vat" | translate }}
      </span>
      <span class="bold">
        {{ calculateVATForProducts(products, vat_included, vat_rate) }}.-
      </span>
    </div>
    <span class="underline bold lato">
      {{ "price_breakdown.shipping" | translate }}
    </span>
    <div
      v-for="[store] in Object.entries(getProductsGroupedByStore)"
      v-bind:key="store"
      class="flex justify-space-between"
    >
      <span>
        {{ "price_breakdown.shipping_at" | translate }}
        {{ `store.${store}` | translate }}
      </span>
      <span>CHF xx.-</span>
    </div>
    <div class="flex justify-space-between">
      <span class="bold">
        {{ "price_breakdown.total_shipping" | translate }}
      </span>
      <span class="bold overline">CHF xx.-</span>
    </div>
    <div class="flex justify-space-between total">
      <!--{{ calculateSubtotal(products, vat_included, vat_rate) }}-->
      <span class="bold">
        {{ "price_breakdown.total" | translate }}
        <span class="light">
          ({{ "price_breakdown.include_vat" | translate }})
        </span>
      </span>
      <span class="bold"
        >CHF {{ calculateTotal(products, vat_included, vat_rate) }}.-</span
      >
    </div>
  </div>
</template>

<script>
import { cartMethods, productImageResizer } from "../../mixins";
export default {
  name: "PriceBreakdown",
  mixins: [cartMethods, productImageResizer],
  data() {
    return {
      vat_rate: 0.24,
      vat_included: true,
      credit_cards: ["MasterCard", "Visa", "Diner's Club"]
    };
  },
  methods: {
    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },
    sumProductPrices(products) {
      return products.reduce(
        (prev, curr) =>
          (prev += curr.count * (curr.priceSale || curr.priceOriginal)),
        0
      );
    },
    sumProductCounts(products) {
      return products.reduce((prev, curr) => (prev += curr.count), 0);
    },
    calculateVAT(sum, vat_included, rate) {
      return this.roundToTwo(
        vat_included ? sum * (rate / (1 + rate)) : sum * rate
      );
    },
    calculateSubtotal(products, vat_included, rate) {
      return vat_included
        ? this.sumProductPrices(products) / (1 + rate)
        : this.sumProductPrices(products);
    },
    calculateVATForProducts(products, vat_included, rate) {
      const sum = this.sumProductPrices(products);
      return this.calculateVAT(sum, vat_included, rate);
    },
    calculateTotal(products, vat_included, rate) {
      return (
        this.sumProductPrices(products) +
        (vat_included
          ? 0
          : this.calculateVATForProducts(products, vat_included, rate))
      );
    },
    checkoutClicked(event) {
      event && event.preventDefault();
      this.$router.push({ name: "CheckoutPage" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.price-breakdown {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: $brand-white;
  justify-content: right;
}

.summary {
  font-weight: 700;
  font-size: $font-base;
  margin-bottom: 1.5rem;
}

.underline {
  border-bottom: 1px solid $brand-black;
  margin-bottom: 1rem;
}

.overline {
  border-top: 1px solid $brand-black;
}

.lato {
  font-family: "Lato";
  font-size: $font-sm;
}

span {
  font-size: $font-xs;
  margin-bottom: 0.5rem;

  &.bold {
    font-weight: 700;
  }

  &.light {
    font-size: 12px;
    font-weight: 200;
  }
}

.total {
  margin-top: 1rem;
  border-top: 1px solid $brand-black;
}
</style>
